import React from "react";
import FormFieldSet from "../../FormFields/FormFieldSet";
import {
  onboardingDocumentCategory,
  onboardingDocumentType,
} from "../../../assets/data/enumData";

export const DrawerDetailsStep = ({
  documentForm,
  setDocumentForm,
  documentType,
}) => {
  return (
    <div className="space-y-4">
      {/* <div>
        <FormFieldSet
          type="radio"
          title="To Be Filled By"
          options={[
            { label: "Applicant", value: 1 },
            { label: "Vendor", value: 2 },
            { label: "Client", value: 3 },
          ]}
          value={documentType}
          required
        />
      </div> */}
      <p className="text-md">
        To Be filled By:{" "}
        <span className="font-semibold">
          {documentType === 1
            ? "Applicant"
            : documentType === 2
            ? "Vendor"
            : "Client"}
        </span>
      </p>

      <div>
        <FormFieldSet
          value={documentForm.documentName}
          onChange={(value) =>
            setDocumentForm({
              ...documentForm,
              documentName: value,
            })
          }
          placeholder="Enter document name"
          title="Document Name"
          required
        />
      </div>

      <div>
        <FormFieldSet
          title="Document Category"
          type="select"
          placeholder="Select Category"
          options={onboardingDocumentCategory}
          value={documentForm.category}
          onChange={(value) =>
            setDocumentForm({
              ...documentForm,
              category: value,
            })
          }
          required
        />
      </div>

      <div>
        <FormFieldSet
          title="Document Type"
          type="select"
          placeholder="Select Type"
          options={onboardingDocumentType}
          value={documentForm.type}
          onChange={(value) =>
            setDocumentForm({
              ...documentForm,
              type: value,
            })
          }
          required
        />
      </div>

      <div>
        <FormFieldSet
          type="textArea"
          title="Description"
          rows={5}
          placeholder="Enter Description"
          value={documentForm.description}
          onChange={(value) =>
            setDocumentForm({
              ...documentForm,
              description: value,
            })
          }
        />
      </div>
    </div>
  );
};
